import type { ReactNode } from 'react';

/** Titled surface container — header bar + padded body. */
export function Card({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="surface rounded-lg overflow-hidden">
      <header className="px-5 py-3 border-b border-breaker-line bg-breaker-ground-2">
        <h2 className="text-2xs font-medium uppercase tracking-wider text-breaker-ink-2">
          {title}
        </h2>
      </header>
      <div className="px-5 py-4">{children}</div>
    </section>
  );
}
